import { put, takeLatest } from 'redux-saga/effects'
import { Action } from 'redux'
import { rootActions } from '@app-store/slices'
import axios from '@utils/request'
import { ISuggestMeetingRequestByIDPayload } from '@app-store/slices/meetingRequests/suggestById'

interface TaskAction extends Action {
    payload: ISuggestMeetingRequestByIDPayload
}

const { onRequest, onSuccess, onFailure } = rootActions.meetingRequests.suggestByID

function* createMeetingRequestByIDSagaTask({ payload }: TaskAction) {
    try {
        const response = yield axios.put(`/meeting/meeting-requests/suggest-by-id/${payload.requestId}`, payload.data)
        if (response.success) {
            yield put(onSuccess(response.result))
            if (payload?.sagaCB?.onSuccess) payload.sagaCB.onSuccess()
        } else {
            throw new Error('')
        }
    } catch (error) {
        yield put(onFailure(error))
        if (payload?.sagaCB?.onError) payload?.sagaCB?.onError()
    }
}

function* createMeetingRequestByIDSaga(): any {
    yield takeLatest<TaskAction>(onRequest, createMeetingRequestByIDSagaTask)
}

export default createMeetingRequestByIDSaga
